import { render, staticRenderFns } from "./IssuedLiquidationsList.vue?vue&type=template&id=08bd9aa9&"
import script from "./IssuedLiquidationsList.vue?vue&type=script&lang=js&"
export * from "./IssuedLiquidationsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports